import React, { useEffect } from "react";
import { FONTS } from "../constants/Fonts";
import { IMAGE_CONSTANTS } from "../constants/ImageConstans";
import { handleCustomConfettiClick } from "../components/base/ConfettiView";

const ClaimedSuccessfullModal = ({
  open,
  dissmissClaimedSuccessfullModal,
  claimType = [
    {
        "userId": "23470ce7e18e61e220bb2d7a",
        "gameId": "69678c4dbd6871f3db20544b",
        "claimType": "early_five",
        "ticketId": "69678c4dbd6871f3db205456",
        "status": "claimed",
        "name": "Rahul Singh faujdar",
        "avatar": "https://d3442bm75jwfo3.cloudfront.net/rapchik-profile-picture/0123bdda-3081-7098-be0d-2d5206481261/1768221075681_profile_edit_5954158954527799166.jpg",
        "displayClaimType": "EARLY FIVE1",
        "matchedEntity": [
            "694a5346c33a7144f4eb0825",
            "694a5346c33a7144f4eb0824",
            "694a5348c33a7144f4eb083f",
            "6947f967c33a7144f4eb07c3"
        ],
        "notMatchedEntity": []
    },
   
  ]
}) => {
  // claimType can be an array of claim objects or a string
  let claimTypeList = [];
  
  // Always call hooks at the top level
  useEffect(() => {
    if (open) {
      console.log('ClaimedSuccessfullModal opened with claimType : ', claimType);
      handleCustomConfettiClick({ onBlastFinished: () => { }, angle: 360 });
      const timer = setTimeout(() => {
        dissmissClaimedSuccessfullModal();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  if (!open) return null;

  if (Array.isArray(claimType)) {
    claimTypeList = claimType
      .filter(c => c.status === 'claimed');
  } else if (typeof claimType === 'string') {
    claimTypeList = [claimType];
  }

  console.log('ClaimedSuccessfullModal claimTypeList : ', claimTypeList);

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <img
          src={IMAGE_CONSTANTS.V2_RAP_HOUSIE_CLAIM_COMPLETED}
          alt="Game Paused"
          style={styles.image}
        />
        <div style={styles.gradientText}>
          {claimTypeList?.length > 0 ? (
            <>
              {claimTypeList?.map((type, idx) => (
                <div key={idx}>{type?.displayClaimType} Completed</div>
              ))}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: `url(${IMAGE_CONSTANTS.BLUR_BACKGROUND_2}) center center / cover no-repeat`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },

  modal: {
    flex:0.3,
    textAlign: "center",
    userSelect: "none",
    height: "auto",
    width: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#121212",
    borderRadius: "20px",
    padding: "40px",
  },

  image: {
    width: "130px",
    height: "130px",
    objectFit: "contain",
    marginTop: "50px",
    marginBottom: "50px",
  },

  gradientText: {
    fontSize: "36px",
    fontWeight: 700,
    color: '#5FE72E',
    fontFamily: FONTS.MONTSERRAT_MEDIUM,
    overflowY: 'auto',
    scrollbarWidth: 'none', /* Firefox */
    msOverflowStyle: 'none', /* IE and Edge */
    marginBottom: "50px",
  },
};

export default ClaimedSuccessfullModal;
